/* unplugin-vue-components disabled */import script from "./BindCustomerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BindCustomerModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__